<div class="p-grid">
    <div class="p-col-12 p-lg-6">
        <div class="card">
            <h5>Toast</h5>
            <p-toast key="tst"></p-toast>

            <button type="button" pButton (click)="showSuccessViaToast()" label="Success" class="p-button-success p-mr-2 p-mb-2"></button>
            <button type="button" pButton (click)="showInfoViaToast()" label="Info" class="p-button-info p-mr-2 p-mb-2"></button>
            <button type="button" pButton (click)="showWarnViaToast()" label="Warn" class="p-button-warning p-mr-2 p-mb-2"></button>
            <button type="button" pButton (click)="showErrorViaToast()" label="Error" class="p-button-danger p-mb-2"></button>
        </div>
    </div>

    <div class="p-col-12 p-lg-6">
        <div class="card">
            <h5>Messages</h5>
            <button type="button" pButton (click)="showSuccessViaMessages()" label="Success" class="p-button-success p-mr-2 p-mb-2"></button>
            <button type="button" pButton (click)="showInfoViaMessages()" label="Info" class="p-button-info p-mr-2 p-mb-2"></button>
            <button type="button" pButton (click)="showWarnViaMessages()" label="Warn" class="p-button-warning p-mr-2 p-mb-2"></button>
            <button type="button" pButton (click)="showErrorViaMessages()" label="Error" class="p-button-danger p-mb-2"></button>

            <p-messages [value]="msgs"></p-messages>
        </div>
    </div>

    <div class="p-col-12 p-lg-8">
        <div class="card">
            <h5>Inline Message</h5>
            <div class="p-mt-4">
                <input type="text" pInputText placeholder="Username" class="ng-dirty ng-invalid p-invalid p-mr-2">
                <p-message severity="error" text="Field is required"></p-message>
            </div>

            <div class="p-mt-4">
                <input type="text" pInputText placeholder="Email" class="ng-dirty ng-invalid p-invalid p-mr-2">
                <p-message severity="error"></p-message>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-lg-4">
        <div class="card">
            <h5>Help Text</h5>
            <div class="p-field p-fluid">
                <label for="username">Username</label>
                <input id="username" type="username" aria-describedby="username-help" class="ng-invalid ng-dirty" pInputText />
                <small id="username-help" class="p-error">Username is not available.</small>
            </div>
        </div>
    </div>


</div>
